import { Box, CardContent, styled, Typography } from '@mui/material';

export const TitleCardContent = styled(CardContent)(({ theme }) => ({
    background: theme.palette.background.contrastBackground.main,
}));

export const ConditionFormCardContent = styled(CardContent)(({ theme }) => ({
    paddingTop: 0,
    marginTop: theme.spacing(3),
}));

export const Hint = styled(Typography)(() => ({
    fontWeight: 500,
}));

export const RowInfo = styled(Typography)(() => ({
    // fontWeight: 500,
    marginBottom: 8,
    fontSize: '0.95rem',
}));

export const Row = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
}));

export const SectionTitle = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3),
    margin: theme.spacing(0, 2),
    marginTop: theme.spacing(3),
    backgroundColor: theme.palette.primary.main,
    borderRadius: theme.shape.borderRadius,

    color: '#fff',
}));

export const TextInputContainer = styled(Box)(({ theme }) => ({
    width: 360,
    marginLeft: theme.spacing(2),

    '& > div': {
        width: '100%',
    },
}));
